var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLucreeNegativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.257 26.997L16.7911 32.5156L22.903 26.4208L28.0454 31.5487L21.9335 37.6435L27.4703 43.1593L30.5263 40.0953L36.0575 45.6138L27.2619 54.3848L0 27.1909L14.8936 12.3418L20.4249 17.8576L11.257 26.997Z",
    fill: "#4A4A49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2807 27.3878L37.7494 21.8692L31.6375 27.964L26.4952 22.8361L32.6071 16.7413L27.0758 11.2255L24.0032 14.2729L18.4719 8.77096L27.2703 0L54.5378 27.1911L39.6441 42.043L34.1129 36.5272L43.2807 27.3878Z",
    fill: "#4A4A49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucreeNegativo);
export default __webpack_public_path__ + "static/media/lucreeNegativo.be7564885c2cbdf8370231e9ddd60f02.svg";
export { ForwardRef as ReactComponent };